import React from 'react';
import { useParams } from 'react-router-dom';
import PageHeader from '../../components/common/PageHeader/PageHeader';
import DocumentUploadView from '../../components/datamanagement/DocumentUploadView';

/**
 * DocumentUploadPage — Page wrapper for the Document Upload view.
 *
 * Follows the same layout pattern as DataEntryPage:
 *   - Scrollable outer container with py-2 py-md-3 px-2 px-md-4
 *   - PageHeader (blue banner, rounded-top)
 *   - Content below
 *
 * Route: /business/data-upload/:id
 */
const DocumentUploadPage = () => {
    const { id } = useParams();

    return (
        <div className="d-flex flex-column h-100 overflow-hidden overflow-y-auto py-2 py-md-3 px-2 px-md-4">
            <div
                className="d-flex flex-column flex-grow-1 mx-auto w-100"
                style={{ maxWidth: '960px' }}
            >
                {/* ── Blue header banner ── */}
                <div className="flex-shrink-0">
                    <PageHeader title="Document Upload" />
                </div>

                {/* ── Document Upload Content ── */}
                <div className="flex-grow-1 d-flex flex-column overflow-hidden overflow-y-auto">
                    <DocumentUploadView dataEntryId={id} />
                </div>
            </div>
        </div>
    );
};

export default DocumentUploadPage;
